export const CartonReturnConstants = {

    // Fetch Carton Return Data
    GETALL_REQUEST: 'CARTON_RETURN_GETALL_REQUEST',
    GETALL_SUCCESS: 'CARTON_RETURN_GETALL_SUCCESS',
    GETALL_FAILURE: 'CARTON_RETURN_GETALL_FAILURE',

    // Loading Flag
    LOADING_REQUEST: 'CARTON_RETURN_LOADING_REQUEST'
};